import { NeoState } from '../Reducers.interface';

export const selectEventProducts = (state: NeoState) =>
  state?.products?.eventProducts?.products || [];
